/**
 * PRR-317. The smallest browser-download primitive the Pay Run ABA action needs: hand the blob to the browser
 * and release the temporary object URL once the download has been dispatched. The bytes are never retained in
 * application state, never rendered and never logged.
 */
const REVOKE_DELAY_MS = 1_000;

export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = 'noopener';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    // The browser dispatches the download asynchronously. Revoking synchronously in this same task
    // truncates or cancels it in some browsers, which for a banking file would be the worst failure
    // mode: a partial .aba that still looks successful. Revoke on a later task instead.
    setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
  }
};
